import { Label, Radio, RadioGroup } from '@headlessui/react'

import cn from '@/utilities/cn'

type RadioGroupProps = {
  name?: string
  value: any
  options: any[]
  onChange: (value: any) => void
  disabled?: boolean
  className?: string
}

const RadioGroupComponent = ({ value, options, onChange, disabled = false, ...rest }: RadioGroupProps) => {
  return (
    <RadioGroup value={value} onChange={onChange} {...rest}>
      <div className="flex space-x-2">
        {options.map(option => (
          <Radio
            key={option}
            value={option}
            disabled={disabled}
            className={({ focus, checked }) =>
              cn(
                focus ? 'ring-2 ring-blue-600 ring-offset-2' : '',
                checked ? 'bg-blue-600 text-white' : 'bg-white text-gray-900 ring-1 ring-inset ring-gray-300',
                checked && !disabled ? 'hover:bg-blue-500' : '',
                !checked && !disabled ? 'hover:bg-gray-50' : '',
                disabled ? 'cursor-not-allowed opacity-50' : 'hover:cursor-pointer',
                'flex items-center justify-center rounded-md py-3 px-3 text-sm font-semibold capitalize shadow-sm sm:flex-1'
              )
            }
          >
            <Label as="span">{option}</Label>
          </Radio>
        ))}
      </div>
    </RadioGroup>
  )
}
export default RadioGroupComponent
